import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useAuthStore } from '../stores/authStore.js'
import { canManageOrders } from '../lib/config/roles.js'

/**
 * Role guard for the order editor routes (/order/new, /order/edit/:uid,
 * /order/duplicate/:uid).
 *
 * Must wrap the routes rather than gate inside the pages: OrdersDuplicatePage
 * fires `api.getOrderByUid` on mount, before any in-page check could run.
 *
 * ProtectedLayout already holds the route until `user` is hydrated, so this
 * never sees a transient undefined role and cannot redirect-flicker.
 */
export function OrderEditorLayout() {
  const user = useAuthStore((s) => s.user)
  if (!canManageOrders(user?.role)) return <Navigate to='/' replace />
  return <Outlet />
}
